import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'
import { fetchTaskLogsPage } from '@/entities/task/api/tasksApi'
import { TaskLogFilter } from '../ui/lib/taskTypes'
import {
  taskLogsKeys,
  mapFilterToLevel,
  getTaskLogsNextPageParam,
} from './taskLogsQuery.lib'

const LOGS_PAGE_SIZE = 100
const POLLING_TIMER = 10000

export interface UseTaskLogsQueryOptions {
  enabled: boolean
  isStarted: boolean
}

export const taskLogsInfiniteQueryOptions = (
  taskId: string,
  filter: TaskLogFilter,
  { enabled, isStarted }: UseTaskLogsQueryOptions
) =>
  infiniteQueryOptions({
    queryKey: taskLogsKeys.filter(taskId, filter),
    queryFn: ({ pageParam }) =>
      fetchTaskLogsPage(taskId, {
        pageNumber: pageParam,
        pageSize: LOGS_PAGE_SIZE,
        level: mapFilterToLevel(filter),
      }),
    initialPageParam: 0,
    getNextPageParam: (_lastPage, allPages) =>
      getTaskLogsNextPageParam(allPages, filter, LOGS_PAGE_SIZE),
    enabled: enabled && !!taskId,
    refetchInterval: isStarted ? POLLING_TIMER : false,
  })

export const useTaskLogsQuery = (
  taskId: string,
  filter: TaskLogFilter,
  options: UseTaskLogsQueryOptions
) => useInfiniteQuery(taskLogsInfiniteQueryOptions(taskId, filter, options))
